export default "__VITE_ASSET__CLJFA6TR__"